import React from 'react'
import NextBoxDiaryDetailsHeader from './NextBoxDiaryDetailsTable/NextBoxDiaryDetailsHeader'
import NextBoxDiaryDetailsRow from './NextBoxDiaryDetailsTable/NextBoxDiaryDetailsRow'
import { Empty } from 'antd'

function NextBoxDiaryDetailsTable(props) {
    const { listData, reset, detailsId, currentDate, selectedAll, listSelecteds, handleChangeSelectAll, handleSelected, openAction, toggleAction } = { ...props }

    return (
        <div className='NextBoxDiaryDetailsTable'>
            <table className="table table-striped">
                <NextBoxDiaryDetailsHeader
                    handleChangeSelectAll={handleChangeSelectAll}
                    selectedAll={selectedAll}
                    listSelecteds={listSelecteds}
                    openAction={openAction}
                    toggleAction={toggleAction}
                    currentDate={currentDate}
                    detailsId={detailsId}
                    reset={reset}
                />
                <tbody className='NextBoxDiaryDetailsRow'>
                    {listData.length > 0 ?
                        listData.map((i, index) => (
                            <NextBoxDiaryDetailsRow
                                key={`NextBoxDiaryDetailsRow_${index}`}
                                item={i}
                                index={index}
                                detailsId={detailsId}
                                reset={reset}
                                currentDate={currentDate}
                                listSelecteds={listSelecteds}
                                handleSelected={handleSelected}
                            />
                        )) :
                        <tr>
                            <td colSpan={4}>
                                <Empty description='Không có dữ liệu' />
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default NextBoxDiaryDetailsTable